import { trackSaveProperty } from '../../../../../analytics/event-tracking/trackSaveProperty';
import { PropertyRelationship } from '../../../../../components/PropertyRelationship/PropertyRelationship';
import { useFollowedProperties } from '../../../../hooks/useFollowedProperties';
import { usePropertyId } from '../../../../../contexts/PropertyIdContext/PropertyIdContext';
import { usePropertyPageQuery } from '../../../../graphql/usePropertyPageQuery';
import { FollowPropertyModal } from '../../../../../components/PropertyRelationship/FollowPropertyModal/FollowPropertyModal';
import { followPropertyModalPageSource } from '../../../../../components/PropertyRelationship/FollowPropertyModal/FollowPropertyModalPageSource';
import type { FunctionComponent } from 'react';

interface FollowPropertyModalWithDataProps {
  opened: boolean;
  onClose: () => void;
  defaultRelationship?: boolean;
}

export const FollowPropertyModalWithData: FunctionComponent<FollowPropertyModalWithDataProps> = ({
  opened,
  onClose,
  defaultRelationship,
}) => {
  const propertyPage = usePropertyPageQuery();
  const followPropertyModal = propertyPage?.data.propertyPageBySlugV3.followPropertyModalV2;
  const { followProperty, loading } = useFollowedProperties();
  const propertyId = usePropertyId();

  if (!followPropertyModal) return null;

  const title = 'Follow this property';
  const { subtitle, image } = followPropertyModal;

  const onSubmitFollowProperty = (propertyRelationship: PropertyRelationship) => {
    void followProperty(propertyId, propertyRelationship);
    trackSaveProperty({
      user_action: 'save',
      property_relationship: propertyRelationship,
      in_page_source: [
        'property_page',
        followPropertyModalPageSource,
        'set_property_relationship_button',
      ].join('__'),
    });
    onClose();
  };

  return (
    <FollowPropertyModal
      title={title}
      subtitle={subtitle}
      image={image}
      opened={opened}
      onClose={onClose}
      onSubmit={onSubmitFollowProperty}
      loading={loading}
      defaultSelection={
        defaultRelationship ? PropertyRelationship.myHome : PropertyRelationship.interested
      }
    />
  );
};
